export function assert(condition, message = 'assertion failed') {
    if (!condition) {
        throw new Error(message);
    }
}
export function nonNilFilter(value) {
    return value != null;
}
//# sourceMappingURL=assert.js.map